module.exports = __webpack_public_path__ + "static/media/catoffline_medium.e7fd8e23.jpg";